<template>
	<view class="page_bg">
		<mp-html :content="richText"></mp-html>
	</view>
</template>

<script>
	var that; // 当前页面对象
	var vk; // vk依赖
	export default {
		data() {
			// 页面数据变量
			return {
				richText: ''
			}
		},
		// 监听 - 页面每次【加载时】执行(如：前进)
		onLoad(options = {}) {
			that = this;
			vk = that.vk;
			that.init(options)
		},
		// 监听 - 页面【首次渲染完成时】执行。注意如果渲染速度快，会在页面进入动画完成前触发
		onReady() {},
		// 监听 - 页面每次【显示时】执行(如：前进和返回) (页面每次出现在屏幕上都触发，包括从下级页面点返回露出当前页面)
		onShow() {},
		// 监听 - 页面每次【隐藏时】执行(如：返回)
		onHide() {},
		// 函数
		methods: {
			// 页面数据初始化函数
			init(options) {
				uni.setNavigationBarTitle({
					title: options.type == '1' ? '隐私政策' : '用户须知及使用协议'
				})
				vk.callFunction({
					url: 'client/policy/pub/get_policy',
					title: '请求中...',
					data: {
						type: Number(options.type)
					},
					success: (res) => {
						if (!res.data) {
							that.richText = '暂无说明'
							return
						}
						that.richText = res.data.content
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page_bg {
		padding: 26rpx;
	}
</style>
